import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPercentage(value: number | string): string {
  const num = Number(value);
  if (isNaN(num)) return "0,0%";
  return `${num.toFixed(1).replace(".", ",")}%`;
}

export function formatCompactScore(score: string | number | null | undefined): string {
  if (score === null || score === undefined) return "";
  const str = String(score);
  return str
    .replace(/\bR\s*:/gi, "CE:")
    .replace(/\bL\s*:/gi, "CO:")
    .replace(/\bW\s*:/gi, "EE:")
    .replace(/\bReading\s*:/gi, "CE:")
    .replace(/\bListening\s*:/gi, "CO:")
    .replace(/\bWriting\s*:/gi, "EE:");
}
